import { AuthError, NetworkError, NotFoundError, ValidationError, errorFromResponse } from "./errors.js";

const BASE = "/api/okrs";

async function apiFetch(url, options = {}) {
  let res;
  try {
    res = await fetch(url, options);
  } catch (err) {
    throw new NetworkError(`Network error: ${err.message}`);
  }
  if (!res.ok) {
    throw await errorFromResponse(res);
  }
  return res.json();
}

export async function getOkrs(lens = "overall", year) {
  let url = `${BASE}?lens=${encodeURIComponent(lens)}`;
  if (year) url += `&year=${encodeURIComponent(year)}`;
  return apiFetch(url);
}

export async function getOkrsDigest(year, month) {
  return apiFetch(`${BASE}/digest?year=${encodeURIComponent(year)}&month=${encodeURIComponent(month)}`);
}

export async function downloadOkrsExecStatus(year, month) {
  let response;
  try {
    response = await fetch(`${BASE}/exec-status.pptx?year=${encodeURIComponent(year)}&month=${encodeURIComponent(month)}`);
  } catch (err) {
    throw new NetworkError(`Network error: ${err.message}`);
  }
  if (!response.ok) throw await errorFromResponse(response);
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `okr-exec-status-${month}.pptx`;
  document.body.append(link);
  try { link.click(); } finally {
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  }
}

export async function createObjective(payload) {
  return apiFetch(`${BASE}/objectives`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export async function updateObjective(id, patch) {
  return apiFetch(`${BASE}/objectives/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
}

export async function createKeyResult(payload) {
  return apiFetch(`${BASE}/key-results`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export async function updateKeyResult(id, patch) {
  return apiFetch(`${BASE}/key-results/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
}

export async function createInitiative(payload) {
  return apiFetch(`${BASE}/initiatives`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export async function updateInitiative(id, patch) {
  return apiFetch(`${BASE}/initiatives/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
}

export async function putInitiativeUpdate(initiativeId, month, payload) {
  return apiFetch(`${BASE}/initiatives/${encodeURIComponent(initiativeId)}/updates/${encodeURIComponent(month)}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
